module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_nordmaling-fabd7279c66f1c4ba4858800f91748a9.png";